export const ADD_STEP = "ADD_ASSISTANT_STEP";
export const DELETE_STEP = "REMOVE_ASSISTANT_STEP";
export const UPDATE_STEP = "UPDATE_ASSISTANT_STEP";
export const ADD_OPTION_TO_STEP = "ADD_CURRENT_ASSISTANT_STEP_OPTION";
export const UPDATE_OPTION_TO_STEP = "UPDATE_OPTION_TO_STEP";
export const REMOVE_CURRENT_ASSISTANT_STEP_OPTION = "REMOVE_CURRENT_ASSISTANT_STEP_OPTION";
export const CHANGE_TYPE_ASSISTANT_STEP = "CHANGE_TYPE_ASSISTANT_STEP";
export const SET_CURRENT_STEP_INDEX = "SET_CURRENT_STEP_INDEX";
export const SELECT_OPTION = "SELECT_OPTION";
export const REMOVE_OPTION_FROM_STEP = "REMOVE_OPTION_FROM_STEP";
export const RESET_ASSISTANT = "RESET_ASSISTANT";
export const LOAD_STEPS = "LOAD_STEPS";
export const UPDATE_STEP_ALL_ATRIBUTES = "UPDATE_STEP_ALL_ATRIBUTES";
export const ADD_TRIGGER_TO_STEP_OPTION = "ADD_TRIGGER_TO_STEP_OPTION";
export const REMOVE_TRIGGER_FROM_STEP_OPTION = "REMOVE_TRIGGER_FROM_STEP_OPTION";
